module.exports = __webpack_public_path__ + "img/mugshot-2.99d2b150.png";